import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useForm } from '../../hooks/useForm'
import backArrowIcon from '../../assets/img/back-arrow.png';
import "../../assets/css/common.css";
import { useAuth } from '../../routers/AuthProvider';
import { useParams } from 'react-router-dom';
import { useFetchData } from '../../hooks/useFetchData';
import { API_URL } from '../../utils/constant';
import axios from 'axios';
import { Toast } from '../../components/ToastComponent';


export default function EditGift() {
    const { id } = useParams();
    const location = useLocation();
    const { initialData } = location.state;
    const backPath = `/loyalty/gift/list`;
    const { handleInputChange, formData, submitForm, setError, error } = useForm();
     useEffect(()=>{
                      if(error){
                         Toast.fire({
                  title: error ,
                  icon: "error",
                });
                      }
                  },[error])
    const navigate = useNavigate();
    const { user, setLoading } = useAuth();

         const [errorMessage, setErrorMessage] = useState("");
        const [stock, setStock] = useState();
    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true)
        const data = {
            ...formData,
            status: 'ACTIVE',
        }
        submitForm('PUT', `/present/${id}`, data, () => {
        //     navigate(backPath)
        // });
        navigate(backPath)
        }, "Successfully Updated");
    }
    return (
        <div className='sub-page-layout-1'>
            <Link className='back-to-page' to={backPath}>
                <img src={backArrowIcon} />
                Back
            </Link>
            <div className='container' style={{ height: 'auto' }}>
                <h1 className='sub-page-title'>Edit Gift</h1>
                <div className='form-container'>
                    <form onSubmit={onSubmit} className='form flex flex-col justify-between w-full'>
                        <h2 className='sub-title mb-8'>Gift Information</h2>
                        <div className='grid grid-cols-2 gap-9'>
                            <div className='grow'>
                                <label className='x-label input-required'>Gift Name</label>
                                <input type='text'
                                    required
                                    defaultValue={initialData.present_name}
                                    name='present_name'
                                    onChange={handleInputChange}
                                    className='x-input' />
                            </div>
                            <div className='grow'>
                                <label className='x-label input-required'>Stock</label>
                                <input type='text'
                                 inputMode='numeric'
                                    required
                                    defaultValue={initialData.stock}
                                    name='stock'
                                    autoComplete='false'
                                    //onChange={handleInputChange}
                                    pattern="[0-9]{1,}"
                                    onChange={e => {
                                        const numericValue = e.target.value.replace(/[^0-9]/g, "");
                                        setStock(numericValue);

                                        const numeric = parseInt(numericValue, 10);

                                        if (!numericValue) {
                                            setErrorMessage("Please enter a number.");
                                        } else if (isNaN(numeric) || numeric < 1) {
                                            setErrorMessage("Number must be 1 or greater.");
                                        } else {
                                            setErrorMessage(""); // Clear message when valid
                                        }
                                        handleInputChange({ target: { name: 'stock', value: numericValue } });
                                    }}

                                    onKeyDown={e => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                        }
                                    }}
                                    className='x-input' />
                                    {errorMessage && (
                                    <div className="text-red-500 text-sm mt-1">{errorMessage}</div>
                                )}
                            </div>
                        </div>
                        <div className='form-btn-group'>
                           
                            <div className='flex justify-end gap-5 mt-5'>
                                <Link to={backPath} className='white-btn'>Cancel</Link>
                                <button className='gold-btn'>Save</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}